module.exports = __webpack_public_path__ + "img/home_img_hover.bc10a857.png";